import {
  Box,
  FormHelperText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import { type FormikProps } from 'formik';
import { useEffect, useState } from 'react';
import { useUbicacionesStore } from '../../stores/ubicaciones/ubicaciones.store';
import transformToOptions from '../../utils/transform-to-options';
import ComboBox from '../ui/Combobox';
import TabPanel from '../ui/TabPanel';
import type { ArticuloFormValues } from './articulo.schema';

type AlmacenesTabProps = {
  value: number;
  formik: FormikProps<ArticuloFormValues>;
  inactivo: boolean;
  loading: boolean;
};

type InventarioItem = {
  idAlmacen: string;
  almacen: string;
  existencia: number;
  idUnidad: string;
  idUbicacion: number;
  ubicacion: string;
};

const AlmacenesTab = ({ value, formik: articuloForm, inactivo, loading }: AlmacenesTabProps) => {
  const { actives: ubicaciones, cargarActivas: cargarUbicacionesActivas } = useUbicacionesStore();
  const [almacenes, setAlmacenes] = useState<InventarioItem[]>([]);

  const updateUbicacion = (index: number, idUbicacion: number) => {
    const ubicacionSeleccionada = ubicaciones.find((u) => u.id === idUbicacion);
    const nuevaUbicacion = ubicacionSeleccionada ? ubicacionSeleccionada.nombre : '';
    const nuevosAlmacenes = [...almacenes];
    nuevosAlmacenes[index] = {
      ...nuevosAlmacenes[index],
      idUbicacion,
      ubicacion: nuevaUbicacion
    };
    setAlmacenes(nuevosAlmacenes);
    articuloForm.setFieldValue('inventario', nuevosAlmacenes);
  };

  useEffect(() => {
    const inventario = articuloForm.values.inventario ?? [];
    setAlmacenes(
      inventario.map((i) => ({
        idAlmacen: i.idAlmacen,
        almacen: i.almacen,
        existencia: i.existencia,
        idUnidad: i.idUnidad,
        idUbicacion: i.idUbicacion,
        ubicacion: i.ubicacion
      }))
    );
  }, [articuloForm.values.inventario]);

  useEffect(() => {
    if (inactivo) return;

    cargarUbicacionesActivas();
  }, [inactivo]);

  const ubicacionesOptions = transformToOptions(ubicaciones);

  return (
    <TabPanel value={value} index={2}>
      <Stack direction="column" component={Paper}>
        <TableContainer>
          <Table sx={{ width: '100%', minHeight: 120 }}>
            <TableHead>
              <TableRow>
                <TableCell>Almacén</TableCell>
                <TableCell>Existencia</TableCell>
                <TableCell>Unidad Base</TableCell>
                <TableCell>Ubicación</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {almacenes.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.almacen}</TableCell>
                  <TableCell>{item.existencia}</TableCell>
                  <TableCell>{item.idUnidad}</TableCell>
                  {inactivo && <TableCell>{item.ubicacion}</TableCell>}
                  {!inactivo && (
                    <TableCell>
                      <ComboBox
                        label="Ubicación"
                        name={`items[${index}].idUbicacion`}
                        disabled={loading}
                        value={item.idUbicacion}
                        onChange={(event) => updateUbicacion(index, event.target.value)}
                        options={ubicacionesOptions}
                      />
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {articuloForm.touched.inventario && Boolean(articuloForm.errors.inventario) && (
          <Box p={2}>
            <FormHelperText error={true}>
              {articuloForm.errors.inventario?.toString()}
            </FormHelperText>
          </Box>
        )}
      </Stack>
    </TabPanel>
  );
};

export default AlmacenesTab;
